import { Accordion, AccordionItem } from "@szhsin/react-accordion";

const FAQAccordion = ({ faqData }) => {
  return (
    <div className="faq-section" id="FAQ">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      {faqData?.find((item) => item?.subHeading) && (
        <p className="faq-intro">
          {faqData?.find((item) => item?.subHeading)?.subHeading}
        </p>
      )}

      <Accordion transition transitionTimeout={250}>
        {faqData?.map((item, index) =>
          item?.question ? (
            <AccordionItem key={index} header={item?.question}>
              <div className="faq-answer">
                <p>{item?.answer}</p>
              </div>
            </AccordionItem>
          ) : null
        )}
      </Accordion>
    </div>
  );
};

export default FAQAccordion;
